import './advertising'
import ga4 from '@/components/modules/ga4'
import sweetAlert from '@/components/modules/sweetAlert'
import axios from 'axios'
import { mapGetters } from 'vuex'
const Cart = {
  mixins: [ga4, sweetAlert],
  computed: {
    ...mapGetters([
      'authorized'
    ])
  },
  methods: {
    getItemUrl (type) {
      const urls = {
        BOOK: '/book/detail/',
        PACKAGE: '/package/detail/',
        ITEM: '/package/detail/',
        MAGAZINE: '/magazine/detail/',
        SUBSCRIPTION: '/magazine/detail/'
      }
      return urls[type] || ''
    },

    async popupAddCart () {
      const { state, dispatch } = this.$store
      await dispatch('isAddingCart', !state.isAddCart)
      dispatch('isAddingCart', true)
    },

    // 加入購物車
    async addShoppingList (item, gifts) {
      const self = this
      const newItem = {
        ...item,
        quantity: 1,
        selected_gifts: gifts || item.selected_gifts || null,
        link: self.getItemUrl(item.type) + (item.link_id || item.id)
      }

      const saveCart = (val) => {
        localStorage.setItem('products', JSON.stringify(val))
        self.$store.dispatch('updateCart')
        // eslint-disable-next-line
        self.authorized ? self.updateCartFunc(self.cleanItems(val)) : null
      }

      const products = JSON.parse(localStorage.getItem('products')) || []
      const digitalCount = products.filter((p) => p.is_digital).reduce((sum, p) => sum + p.quantity, 0)

      if (item.is_digital && digitalCount >= 20) {
        return self.alertPop('warning', '已達電腦互動學習軟體購買上限（20筆）')
      }

      const existingItem = products.find((p) => p.id === item.id)

      if (existingItem) {
        if (item.type === 'SUBSCRIPTION') {
          self.alertPop('warning', '購物車已有同一本雜誌(期數)囉!，欲改數量可至購物車')
        } else if (existingItem.quantity < item.in_stock) {
          existingItem.quantity++
          saveCart(products)
          self.popupAddCart()
        }
      } else {
        products.push(newItem)
        saveCart(products)
        self.popupAddCart()
      }

      // 廣告商代碼
      self.addCartCode({ productID: item.id, unit: '1', price: item.pricing })
    },

    // 更新購物車
    async updatedShoppingList (item) {
      const newItem = {
        ...item,
        quantity: 1,
        link: self.getItemUrl(item.type) + (item.link_id || item.id)
      }

      const saveCart = (val) => {
        localStorage.setItem('products', JSON.stringify(val))
        this.$store.dispatch('updateCart')
        // eslint-disable-next-line
        this.authorized ? this.updateCartFunc(this.cleanItems(val)) : null
      }

      const products = JSON.parse(localStorage.getItem('products')) || []
      const digitalCount = products.filter((p) => p.is_digital).reduce((sum, p) => sum + p.quantity, 0)

      if (item.is_digital && digitalCount >= 20) {
        return self.alertPop('warning', '已達電腦互動學習軟體購買上限（20筆）')
      }

      const existingItem = products.find((p) => p.id === item.id)

      if (existingItem) {
        if (item.type === 'SUBSCRIPTION') {
          self.alertPop('warning', '購物車已有同一本雜誌(期數)囉!，欲改數量可至購物車')
        } else if (existingItem.quantity < item.in_stock) {
          existingItem.quantity++
          saveCart(products)
        }
      } else {
        products.push(newItem)
        saveCart(products)
      }
    },

    // 變更購物車商品數量
    updateQuantity (id, num) {
      const products = JSON.parse(localStorage.getItem('products')) || []
      const product = products.find((p) => p.id === id)
      if (product) {
        product.quantity = num
        localStorage.setItem('products', JSON.stringify(products))
        this.$store.dispatch('updateCart')
        // eslint-disable-next-line
        this.authorized ? this.updateCartFunc(this.cleanItems(products)) : null
      }
    },

    // 刪除購物車
    removeShoppingList () {
      localStorage.removeItem('products')
      this.$store.dispatch('updateCart')
      // eslint-disable-next-line
      this.authorized ? this.updateCartFunc() : null
    },

    // 刪除購物車項目
    removeShoppingItem (id) {
      const products = JSON.parse(localStorage.getItem('products')) || []
      const updatedProducts = products.filter((p) => p.id !== id)
      if (updatedProducts.length) {
        localStorage.setItem('products', JSON.stringify(updatedProducts))

        this.updateCartFunc(this.cleanItems(updatedProducts))
        // eslint-disable-next-line
        this.authorized ? this.updateCartFunc(this.cleanItems(updatedProducts)) : null
      } else {
        localStorage.removeItem('products')
        this.updateCartFunc()
      }
      this.$store.dispatch('updateCart')
    },

    // 刪除過期商品
    removeExpireItem () {
      const products = JSON.parse(localStorage.getItem('products')) || []
      const validProducts = products.filter((item) => !item.expire_time || Date.now() <= item.expire_time)

      if (validProducts.length < products.length) {
        localStorage.setItem('products', JSON.stringify(validProducts))
        this.$emit('removeShopItem', 'refreshCart')

        this.updateCartFunc(this.cleanItems(validProducts))
      }
    },

    getCartFunc () {
      if (!this.authorized) return

      axios.get('/cart/info')
        .then(async (res) => {
          if (res.data && res.data.length > 0) {
            this.$store.dispatch('updateCart', res.data)
          } else {
            this.$store.dispatch('updateCart', [])
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCartFunc2 () {
      if (!this.authorized) return
      // checkout
      axios.get('/cart/info')
        .then(async (res) => {
          if (res.data && res.data.length > 0) {
            this.checkCart(res.data)
          } else {
            this.checkCart([])
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updateCartFunc (data) {
      if (!this.authorized) return
      // eslint-disable-next-line
      let jsonData = data ? data : []
      axios.post('/cart/info', jsonData)
        .then(() => {
          this.$store.dispatch('updateCart')
          this.getCartFunc()
        })
    },
    cleanItems (arr) {
      const keysToKeep = [
        'name', 'pricing', 'type', 'fixed_price', 'cover', 'category_name',
        'free_gifts', 'free_items', 'gift_num', 'id', 'in_stock',
        'is_digital', 'is_favorite', 'quantity', 'selected_gifts', 'in_stock', 'is_tax', 'isRegisteredMail', 'package', 'begin_at', 'end_at'
      ]

      return arr.map(obj =>
        Object.fromEntries(
          Object.entries(obj).filter(([key]) => keysToKeep.includes(key))
        )
      )
    }
  }
}

export default Cart
